import {createStyles, Modal} from "@mantine/core";
import React, {useEffect, useState} from "react";
import FooterButton from "./Features/FooterButton";
import {isMobile} from "../App";
import {useCookieContext} from "../CookieContext";

const useStyles = createStyles(() => ({
    step: {
        width: `${isMobile ? '100%' : '33%'}`,
        borderBottom: `${isMobile ? '1px solid #555' : 'none'}`,
        borderRight: `${isMobile ? 'none' : '1px solid #555'}`,
        padding: 10,
        display: 'flex',
        flexDirection: `${isMobile ? 'row' : 'column'}`,
        '&:last-child': {
            border: 'none',
        },
    },
}));

const ChooseServer = ({serversData}) => {
    const {classes} = useStyles();

    const [opened, setOpened] = useState(false);
    const { refKey } = useCookieContext();

    useEffect(() => {}, [refKey]);

    return (
        <div>
            <button
                className="nk-btn-x2 link-effect-1 nk-btn-color-main-1 ready"
                style={{margin: '-10px 0px', fontFamily: 'Marcellus SC', border: 'none', backgroundColor: '#060606'}}
                onClick={() => setOpened(true)}
                id={'w_button_choose_server'}
            >
                <i className="fa-solid fa-repeat" style={{fontSize: 16, marginRight: 10}}></i>
                <span className="">C</span>
                <span className="">H</span>
                <span className="">O</span>
                <span className="">O</span>
                <span className="">S</span>
                <span className="" style={{marginRight: 5}}>E</span>
                <span className="">S</span>
                <span className="">E</span>
                <span className="">R</span>
                <span className="">V</span>
                <span className="">E</span>
                <span className="">R</span>
            </button>
            <Modal opened={opened} onClose={() => setOpened(false)} centered title="Choose Server" size="calc(100vw - 30%)"
                   styles={() => ({
                       root: {
                           zIndex: 99999,
                       },
                       title: {
                           fontFamily: 'Marcellus SC',
                       },
                       modal: {
                           backgroundColor: '#181818',
                           color: '#fff',
                           maxWidth: 800,

                       },
                       body: {
                           display: 'flex'
                       },
                       close: {
                           '&:hover': {
                               backgroundColor: '#222222',
                               color: '#fff'
                           }
                       }
                   })}
            >
                <div style={{display: 'flex', flexDirection: `${isMobile ? 'column' : 'row'}`, maxWidth: 800, width: '100%', gap: 10}}>
                    {Object.keys(serversData).map((chronicle, index) => (
                        <div key={index} className={classes.step}>
                            <h4 style={{textAlign: 'center', color: '#e08821'}}>{serversData[chronicle].title}</h4>
                            {serversData[chronicle].description && <p style={{textAlign: 'center', height: '100%', alignContent: 'center'}}>{chronicle.description}</p>}
                            {serversData[chronicle].rates && Object.keys(serversData[chronicle].rates).map((rate, index) => (
                                <FooterButton key={index} style={{marginBottom: 10}} matomo_id={`w_button_choose_server_${chronicle}_${rate}`} to={`/${chronicle}-${rate}/features/`} className="link-effect">{rate}</FooterButton>
                            ))}
                        </div>
                    ))}
                </div>
            </Modal>
        </div>
    );
};

export default ChooseServer;